import { render, staticRenderFns } from "./BlogPostCard.vue?vue&type=template&id=231da91a&scoped=true"
import script from "./BlogPostCard.vue?vue&type=script&lang=js"
export * from "./BlogPostCard.vue?vue&type=script&lang=js"
import style0 from "./BlogPostCard.vue?vue&type=style&index=0&id=231da91a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231da91a",
  null
  
)

export default component.exports